module.exports = __webpack_public_path__ + "static/media/jason.8f697825.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/jason.png
// module id = 862
// module chunks = 0